'use client';

import { ReactNode } from 'react';
import { motion, type Variants } from 'motion/react';
import { fadeUp, fadeIn, VIEWPORT } from './tokens';

const variantMap = {
  fadeUp,
  fadeIn,
} satisfies Record<string, Variants>;

type RevealVariant = keyof typeof variantMap | 'none';

type Props = {
  children: ReactNode;
  variant?: RevealVariant;
  delay?: number;
  amount?: number;
};

export default function RevealOnScroll({
  children,
  variant = 'fadeUp',
  delay = 0,
  amount = VIEWPORT.amount,
}: Props) {
  if (variant === 'none') {
    return <>{children}</>;
  }

  return (
    <motion.article
      initial='hidden'
      whileInView='visible'
      viewport={{ once: VIEWPORT.once, amount, margin: VIEWPORT.margin }}
      variants={variantMap[variant]}
      transition={{ delay }}
    >
      {children}
    </motion.article>
  );
}
